namespace Matrix.Rebalancer {
    export class AccountOverrideColumns {
        static columnsKey = 'Rebalancer.AccountOverride';
    }
}
